import React, { useState, useEffect } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import ShadowTable from "../../atoms/ShadowTable";
import Button from "../../atoms/Button";
import { useNavigate } from "react-router-dom";
import { getSubCategories } from "../../../utils/api/getSubCategories";
import {
  updateHighestSDG,
  updateHighestAmountCredits,
  updateHighestDemand
} from "../../../utils/api/dashboardManagement";
import { useAuthContext } from "../../../context/AuthContext";
import toast from "react-hot-toast";
import { getAllSDG } from "../../../utils/api/getAllSDG";

const DashboardMessage = ({
  open,
  onOk,
  onCancel,
  sdgData = [],
  creditsData = [],
  demandData = [],
  sdgDataRange,
  creditsDataRange,
  demandDataRange
}) => {
  const navigate = useNavigate();
  const [editableData, setEditableData] = useState(creditsData);
  const [editablesdgData, setEditableSDGData] = useState(sdgData);
  const [editableDemandData, setEditableDemandData] = useState(demandData);
  const [subCategories, setSubCategories] = useState([]);
  const [sdg, setSdg] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [editableDataRange, setEditableDataRange] = useState("");
  const { setAuthUser } = useAuthContext();

  useEffect(() => {
    const fetchSubCategories = async () => {
      const data = await getSubCategories();
      setSubCategories(data);
    };

    fetchSubCategories();
  }, []);
  useEffect(() => {
    const fetchSDG = async () => {
      const data = await getAllSDG();
      setSdg(data);
    };

    fetchSDG();
  }, []);

  useEffect(() => {
    if (demandData.length) {
      setEditableDemandData(demandData);
      setEditableDataRange(demandDataRange);
    } else if (sdgData.length) {
      setEditableSDGData(sdgData);
      setEditableDataRange(sdgDataRange);
    } else {
      setEditableData(creditsData);
      setEditableDataRange(creditsDataRange);
    }
  }, [
    creditsData,
    demandData,
    sdgData,
    demandDataRange,
    sdgDataRange,
    creditsDataRange
  ]);

  const handleInputChange = (index, field, value) => {
    const updatedData = [
      ...(demandData.length
        ? editableDemandData
        : sdgData.length
        ? editablesdgData
        : editableData)
    ];
    updatedData[index] = { ...updatedData[index], [field]: value };
    if (demandData.length) {
      setEditableDemandData(updatedData);
    } else if (sdgData.length) {
      setEditableSDGData(updatedData);
    } else {
      setEditableData(updatedData);
    }
  };

  const handleSaveChanges = async () => {
    setLoading(true);
    try {
      if (demandData.length) {
        await updateHighestDemand(
          editableDemandData,
          editableDataRange,
          setAuthUser
        );
      } else if (sdgData.length) {
        await updateHighestSDG(editablesdgData, editableDataRange, setAuthUser); // Update API call
      } else {
        await updateHighestAmountCredits(
          editableData,
          editableDataRange,
          setAuthUser
        );
      }
      toast.success("Updated successfully");
      onOk();
    } catch (error) {
      setError("Failed to update data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const headers = demandData.length
    ? ["Rank", "Name", "Percentage"]
    : sdgData.length
    ? ["Rank", "Name", "Percentage"]
    : ["Rank", "Name", "Price", "Volume", "Trend"];

  const body = (
    demandData.length
      ? editableDemandData
      : sdgData.length
      ? editablesdgData
      : editableData
  ).map((credit, index) =>
    demandData.length
      ? [
          credit.rank.toString(),
          <select
            key={index}
            value={credit.name || ""}
            onChange={(e) => handleInputChange(index, "name", e.target.value)}
            className="border rounded px-2 py-1 w-full"
          >
            {subCategories.map((subCategory) => (
              <option key={subCategory._id} value={subCategory.name}>
                {subCategory.name}
              </option>
            ))}
          </select>,
          <input
            key={index}
            type="text"
            value={credit.percentage}
            onChange={(e) =>
              handleInputChange(index, "percentage", e.target.value)
            }
            className="border rounded px-2 py-1 w-full"
          />
        ]
      : sdgData.length
      ? [
          credit.rank.toString(),
          <select
            key={index}
            value={credit.name || ""}
            onChange={(e) => handleInputChange(index, "name", e.target.value)}
            className="border rounded px-2 py-1 w-full"
          >
            {sdg.map((sdg) => (
              <option key={sdg._id} value={sdg.name}>
                {sdg.name}
              </option>
            ))}
          </select>,
          <input
            key={index}
            type="text"
            value={credit.percentage}
            onChange={(e) =>
              handleInputChange(index, "percentage", e.target.value)
            }
            className="border rounded px-2 py-1 w-full"
          />
        ]
      : [
          credit.rank.toString(),
          <select
            key={index}
            value={credit.name}
            onChange={(e) => handleInputChange(index, "name", e.target.value)}
            className="border rounded py-1 w-48"
          >
            <option value="">Select Subcategory</option>
            {subCategories.map((subCategory) => (
              <option key={subCategory._id} value={subCategory.name}>
                {subCategory.name}
              </option>
            ))}
          </select>,
          <input
            key={index}
            type="text"
            value={credit.price}
            onChange={(e) => handleInputChange(index, "price", e.target.value)}
            className="border rounded px-2 py-1 w-12"
          />,
          <input
            key={index}
            type="text"
            value={credit.volume}
            onChange={(e) => handleInputChange(index, "volume", e.target.value)}
            className="border rounded px-2 py-1 w-12"
          />,
          <select
            key={index}
            value={credit.trend}
            onChange={(e) => handleInputChange(index, "trend", e.target.value)}
            className="border rounded px-2 py-1 w-28"
          >
            <option value="Uptrend">Uptrend</option>
            <option value="Downtrend">Downtrend</option>
          </select>
        ]
  );

  return (
    <DiaglogBox open={open} onCancel={onCancel} width={600}>
      <div className="h-[495px] overflow-hidden overflow-y-scroll px-6 no-scrollbar py-3">
        <h1 className="text-lg font-medium mt-4 underline">
          {demandData.length
            ? "Top 5 Credits - In Demand"
            : sdgData.length
            ? "Sdg in Demand"
            : "Top 5 Credits - Highest amount first"}
        </h1>
        <div className="flex gap-x-8">
          <div className="flex items-center mt-5">
            <p className="text-lg font-medium mr-2">Data Range:</p>
            <div className="flex items-center ml-2">
              <input
                type="text"
                value={editableDataRange}
                onChange={(e) => setEditableDataRange(e.target.value)}
                className="border text-[10px] font-normal bg-gray-100 w-[104px] h-[17px] px-1 pt-[2px] rounded underline"
              />
            </div>
          </div>
          <div className="flex items-center mt-5">
            <p className="text-lg font-medium mr-2">Ref Volume -</p>
            <p className="text-[10px] font-normal bg-gray-100 text-gray-800 w-[140px] h-[17px] pt-[2px] px-1 rounded underline">
              100
            </p>
          </div>
        </div>
        <div className="mt-5">
          <ShadowTable headers={headers} rows={body} />
        </div>
        {error && <p className="text-red-600 text-center mt-4">{error}</p>}
        <div className="flex gap-x-5 justify-center items-center">
          <div className="mt-4">
            <Button
              color={"blue"}
              varient={"primary"}
              onClick={handleSaveChanges}
              className={
                "text-white text-[9px] px-20 py-2 font-semibold h-9 bg-blue-600"
              }
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </div>
          <div className="mt-4">
            <Button
              varient={"primary"}
              onClick={onCancel}
              className={
                "text-white text-[9px] px-20 py-2 font-semibold h-9 bg-red-600"
              }
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default DashboardMessage;
